module.exports = __webpack_public_path__ + "img/google_plus.777d8891.svg";